import React from "react";
import PropTypes from "prop-types";

import Drawer from "@material-ui/core/Drawer";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const Explore = () => {
	const toggleDrawer = (anchor, open) => (event) => {
		if (
			event.type === "keydown" &&
			(event.key === "Tab" || event.key === "Shift")
		) {
			return;
		}

		setState({ ...state, [anchor]: open });
	};

	return (
		<Box mr={3} display={{ xs: "none", sm: "block" }}>
			<Button
				color={"secondary"}
				endIcon={<ExpandMoreIcon />}
				onClick={toggleDrawer}
			>
				Explore
			</Button>

			<Drawer
				anchor={anchor}
				open={state[anchor]}
				onClose={toggleDrawer(anchor, false)}
			>
				{list(anchor)}
			</Drawer>
		</Box>
	);
};

export default Explore;
